import React, { FunctionComponent, useRef, useState } from 'react'
import { TrackingEvent } from '../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { CARET_PLACEMENTS, Grid, Icon, Text, Tooltip, useDesignLanguagePerClass } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useTranslation } from 'next-i18next'

export const MobileTerms: FunctionComponent = () => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const [tooltipShow, setTooltipShow] = useState<boolean>(false)
  const [hasNotPressedMobileTerms, setHasNotPressedMobileTerms] = useState(true)
  const { t } = useTranslation()
  const buttonRef = useRef(null)
  const skidding = 20
  const id = 'mobile-terms-tooltip'
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const buttonClassName = designLanguageStyles.triggerButton
  const toolTip = (): JSX.Element => <Text size='S'>{t('common:mobileTerms')}</Text>
  const toggleTooltip = (): void => {
    setTooltipShow(!tooltipShow)

    if (hasNotPressedMobileTerms) {
      logEvent(TrackingEvent.PRESSED_SMS_TERMS)
      setHasNotPressedMobileTerms(false)
    }
  }

  const handleTooltipClose = (): void => {
    setTooltipShow(false)
  }

  const renderMobileTermsTooltip = (): JSX.Element => {
    return (
      <>
        {tooltipShow && (
          <Tooltip
            id={id}
            triggerRef={buttonRef}
            caretPlacement={CARET_PLACEMENTS.BOTTOM_START}
            testNameSpace='mobile-terms-tooltip'
            content={toolTip()}
            usePortal={false}
            skidding={skidding}
            bubbleSize={{ width: '100%' }}
            onClose={handleTooltipClose}
          />
        )}
      </>
    )
  }

  return (
    <Grid>
      <div className={styles.termsWrapper}>
        <button
          type='button'
          className={buttonClassName}
          onClick={toggleTooltip}
          data-testid='mobile-terms-info-btn'
          aria-label={t('common:mobileTermsInfo')}
          aria-describedby={id}
          aria-expanded={tooltipShow}
        >
          <div ref={buttonRef}>
            <Icon.Info size='Small' />
          </div>
          <Grid.FixedItem width={8} />
          <Text size='XS' bold underline renderAs='span' testNameSpace='mobile-terms'>
            {t('common:mobileTermsInfo')}
          </Text>
        </button>
        {renderMobileTermsTooltip()}
      </div>
    </Grid>
  )
}
